import { render, staticRenderFns } from "./ConnectionsPage.vue?vue&type=template&id=5e89dd45&scoped=true"
import script from "./ConnectionsPage.vue?vue&type=script&lang=js"
export * from "./ConnectionsPage.vue?vue&type=script&lang=js"
import style0 from "./ConnectionsPage.vue?vue&type=style&index=0&id=5e89dd45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89dd45",
  null
  
)

export default component.exports